import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";
import {
  University_Web_Details_Form_Checker,
  universityWeb_Details_form,
} from "../../Models/universityWebDetailsModel";
import ReactQuill from "react-quill";
import { useDispatch, useSelector } from "react-redux";
import AlertBox from "../../Components/Alert";
import {
  CREATE_UNIVERSITY_WEB_DETAILS,
  UNIVERSITY_WEB_DETAILS_CREATE_RESET,
  UNIVERSITY_WEB_DETAILS_UPDATE,
  UNIVERSITY_WEB_DETAILS_UPDATE_RESET,
} from "../../Actions/universityWebDetailsAction";

export default function CreateUniversityWebDetails({
  handleFormClose,
  FormOpener,
  EditFormOpener,
  UniversityWebDetialsEditList,
  setUniversityWebDetialsEditList,
  handleEditorForm,
  University_Web_Details_Get_Req,
}) {
  const [UniversityWebDetailsForm, setUniversityWebDetailsForm] = useState(
    universityWeb_Details_form
  );
  const [ClassicEditorInputBox1, setClassicEditorInputBox1] = useState({
    aboutUniversity: "",
  });
  const [ClassicEditorInputBox2, setClassicEditorInputBox2] = useState({
    extraDetails: "",
  });
  const [ClassicEditorInputBox3, setClassicEditorInputBox3] = useState({
    whyText: "",
  });
  const [Alert, setAlert] = useState([]);
  const [University, setUniversity] = useState([]);
  const {
    create_university_web_Loading,
    create_university_web_Error,
    create_university_web_Success,
  } = useSelector((state) => state.CREATE_UNIVERSITY_WEB_DETAILS_REDUCER);

  const {
    update_university_web_Loading,
    update_university_web_Success,
    update_university_web_Error,
  } = useSelector((state) => state.UPDATE_UNIVERSITY_WEB_DETAILS_REDUCER);

  const { UniversityList } = useSelector(
    (state) => state.UNIVERSITY_LIST_REDUCER
  );

  const dispatch = useDispatch();
  const handleFormChange = (e) => {
    if (EditFormOpener) {
      setUniversityWebDetialsEditList({
        ...UniversityWebDetialsEditList,
        [e.target.name]: e.target.value,
      });
    }
    setUniversityWebDetailsForm({
      ...UniversityWebDetailsForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleFormCancel = () => {
    handleFormClose();
    dispatch(UNIVERSITY_WEB_DETAILS_CREATE_RESET());
    setAlert([]);
    setUniversityWebDetailsForm(universityWeb_Details_form);
    setClassicEditorInputBox1({
      aboutUniversity: "",
    });
    setClassicEditorInputBox2({
      extraDetails: "",
    });
    setClassicEditorInputBox3({
      whyText: "",
    });
  };

  const handleEditCancel = () => {
    handleEditorForm();
    setAlert([]);
    dispatch(UNIVERSITY_WEB_DETAILS_UPDATE_RESET());
    setUniversityWebDetailsForm(universityWeb_Details_form);
    setClassicEditorInputBox1({
      aboutUniversity: "",
    });
    setClassicEditorInputBox2({
      extraDetails: "",
    });
    setClassicEditorInputBox3({
      whyText: "",
    });
  };

  /*  University Web Details Create Error and Success handle start  */

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const FormCheck = University_Web_Details_Form_Checker({
      ...UniversityWebDetailsForm,
      ...ClassicEditorInputBox1,
      ...ClassicEditorInputBox2,
      ...ClassicEditorInputBox3,
    });
    if (FormCheck[0] === "success") {
      dispatch(
        CREATE_UNIVERSITY_WEB_DETAILS({
          ...UniversityWebDetailsForm,
          ...ClassicEditorInputBox1,
          ...ClassicEditorInputBox2,
          ...ClassicEditorInputBox3,
        })
      );
    } else {
      setAlert(FormCheck);
    }
  };

  useEffect(() => {
    if (create_university_web_Error) {
      setAlert([create_university_web_Error]);
    }
    if (create_university_web_Success) {
      setAlert([create_university_web_Success]);

      setTimeout(() => {
        handleFormCancel();
        University_Web_Details_Get_Req();
      }, 1200);
    }
  }, [create_university_web_Error, create_university_web_Success]);

  /*  University Web Details Create Error and Success handle End */

  /*  University Web Details Edit Req Error and Success handle  */
  const handleEditFormSubmit = (e) => {
    e.preventDefault();
    const FormCheck = University_Web_Details_Form_Checker({
      ...UniversityWebDetialsEditList,
      ...ClassicEditorInputBox1,
      ...ClassicEditorInputBox2,
      ...ClassicEditorInputBox3,
    });

    if (FormCheck[0] === "success") {
      dispatch(
        UNIVERSITY_WEB_DETAILS_UPDATE({
          ...UniversityWebDetialsEditList,
          ...ClassicEditorInputBox1,
          ...ClassicEditorInputBox2,
          ...ClassicEditorInputBox3,
        })
      );
    } else {
      setAlert(FormCheck);
    }
  };

  useEffect(() => {
    if (update_university_web_Error) {
      setAlert([update_university_web_Error]);
    }
    if (update_university_web_Success) {
      setAlert([update_university_web_Success]);

      setTimeout(() => {
        handleEditCancel();
        University_Web_Details_Get_Req();
      }, 1200);
    }
  }, [update_university_web_Success, update_university_web_Error]);

  /*  University Web Details Edit Req Error and Success handle End  */

  useEffect(() => {
    setUniversity(UniversityList);
  }, [UniversityList]);

  useEffect(() => {
    if (EditFormOpener && UniversityWebDetialsEditList) {
      setClassicEditorInputBox1({
        aboutUniversity: UniversityWebDetialsEditList.aboutUniversity,
      });
      setClassicEditorInputBox2({
        extraDetails: UniversityWebDetialsEditList.extraDetails,
      });
      setClassicEditorInputBox3({
        whyText: UniversityWebDetialsEditList.whyText,
      });
    }
  }, [UniversityWebDetialsEditList]);

  return (
    <>
      <div
        id="CreatContact"
        className={
          FormOpener || EditFormOpener ? "overlay-note w100 " : "overlay-note"
        }>
        <div className="Alert">
          {" "}
          {Alert.length > 0
            ? Alert.map((el, i) => (
                <AlertBox
                  key={i}
                  alert={el}
                  validator={
                    create_university_web_Success ||
                    update_university_web_Success
                      ? true
                      : false
                  }
                />
              ))
            : ""}{" "}
        </div>
        {!EditFormOpener ? (
          <div className="overlay-add-deals contact-right-side">
            <div className="note-title">
              <h4 className="text-left text-white pl-3">
                Create University Web Details
              </h4>
              <a
                href="#"
                className="closebtn text-right text-white"
                onClick={() => handleFormCancel()}>
                &times;
              </a>
            </div>
            <div className="contact-body modify-create-contact">
              <form onSubmit={handleFormSubmit}>
                <div className="form-group">
                  <label>
                    {" "}
                    University Name: <b>*</b>
                  </label>
                  <select
                    className="form-control"
                    value={UniversityWebDetailsForm.universityId}
                    onChange={handleFormChange}
                    name={"universityId"}>
                    <option value="">Select University</option>
                    {University?.map((el) => (
                      <option key={el.University_Id} value={el.University_Id}>
                        {el.University_Name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>
                    {"University details"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter University Details"
                    name={"universityDetails"}
                    value={UniversityWebDetailsForm.universityDetails}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Common Application fees"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Application fees"
                    name={"commonApplicationFee"}
                    value={UniversityWebDetailsForm.commonApplicationFee}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Tuition fees"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Tuition fees"
                    name={"commonTuitionFees"}
                    value={UniversityWebDetailsForm.commonTuitionFees}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Degree offered"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Degree offered"
                    name={"degreeOffered"}
                    value={UniversityWebDetailsForm.degreeOffered}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Google map Url"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter map Url"
                    name={"googleMapUrl"}
                    value={UniversityWebDetailsForm.googleMapUrl}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Neighborhood"}:<b></b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Neighborhood"
                    name={"neighborhood"}
                    value={UniversityWebDetailsForm.neighborhood}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="sed_classic_editor">
                  <label>
                    About University:<span>*</span>
                  </label>
                  <div>
                    <ReactQuill
                      placeholder={"About University"}
                      value={ClassicEditorInputBox1.aboutUniversity}
                      onChange={(e) =>
                        setClassicEditorInputBox1({ aboutUniversity: e })
                      }
                    />
                  </div>
                </div>
                <div className="sed_classic_editor">
                  <label>
                    Extra details:<span>*</span>
                  </label>
                  <div>
                    <ReactQuill
                      placeholder={"Extra details"}
                      name="extraDetails"
                      value={ClassicEditorInputBox2.extraDetails}
                      onChange={(e) =>
                        setClassicEditorInputBox2({ extraDetails: e })
                      }
                    />
                  </div>
                </div>
                <div className="sed_classic_editor">
                  <label>
                    Why text:<span>*</span>
                  </label>
                  <div>
                    <ReactQuill
                      placeholder={"Why Text"}
                      value={ClassicEditorInputBox3.whyText}
                      onChange={(e) =>
                        setClassicEditorInputBox3({ whyText: e })
                      }
                    />
                  </div>
                </div>

                <div className="contact-footer w-100">
                  <button
                    type="submit"
                    disabled={create_university_web_Loading}
                    className="btn">
                    {create_university_web_Loading
                      ? "Loading"
                      : "Create University Web"}
                  </button>

                  <button
                    type="button"
                    className="btn btn-deep-orange waves-effect waves-light"
                    onClick={() => handleFormCancel()}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <div className="overlay-add-deals contact-right-side">
            <div className="note-title">
              <h4 className="text-left text-white pl-3">
                Update University Web Details
              </h4>
              <a
                className="closebtn text-right text-white"
                onClick={() => handleEditCancel()}>
                &times;
              </a>
            </div>

            <div className="contact-body modify-create-contact">
              <form onSubmit={handleEditFormSubmit}>
                <div className="form-group">
                  <label>
                    {" "}
                    University Name: <b>*</b>
                  </label>
                  <select
                    className="form-control"
                    value={UniversityWebDetialsEditList.universityId}
                    onChange={handleFormChange}
                    name={"universityId"}>
                    <option value="">Select University</option>
                    {University?.map((el) => (
                      <option key={el.University_Id} value={el.University_Id}>
                        {el.University_Name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>
                    {"University details"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter University Details"
                    name={"universityDetails"}
                    value={UniversityWebDetialsEditList.universityDetails}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Common Application fees"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Application fees"
                    name={"commonApplicationFee"}
                    value={UniversityWebDetialsEditList.commonApplicationFee}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Tuition fees"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Tuition fees"
                    name={"commonTuitionFees"}
                    value={UniversityWebDetialsEditList.commonTuitionFees}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Degree offered"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Degree offered"
                    name={"degreeOffered"}
                    value={UniversityWebDetialsEditList.degreeOffered}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Google map Url"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter map Url"
                    name={"googleMapUrl"}
                    value={UniversityWebDetialsEditList.googleMapUrl}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Neighborhood"}:<b></b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Neighborhood"
                    name={"neighborhood"}
                    value={UniversityWebDetialsEditList.neighborhood}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="sed_classic_editor">
                  <label>
                    About University:<span>*</span>
                  </label>
                  <div>
                    <ReactQuill
                      placeholder={"About University"}
                      value={ClassicEditorInputBox1.aboutUniversity}
                      onChange={(e) =>
                        setClassicEditorInputBox1({ aboutUniversity: e })
                      }
                    />
                  </div>
                </div>
                <div className="sed_classic_editor">
                  <label>
                    Extra details:<span>*</span>
                  </label>
                  <div>
                    <ReactQuill
                      placeholder={"Extra details"}
                      name="extraDetails"
                      value={ClassicEditorInputBox2.extraDetails}
                      onChange={(e) =>
                        setClassicEditorInputBox2({ extraDetails: e })
                      }
                    />
                  </div>
                </div>
                <div className="sed_classic_editor">
                  <label>
                    Why text:<span>*</span>
                  </label>
                  <div>
                    <ReactQuill
                      placeholder={"Why Text"}
                      value={ClassicEditorInputBox3.whyText}
                      onChange={(e) =>
                        setClassicEditorInputBox3({ whyText: e })
                      }
                    />
                  </div>
                </div>

                <div className="contact-footer w-100">
                  <button
                    type="submit"
                    disabled={update_university_web_Loading}
                    className="btn">
                    {update_university_web_Loading
                      ? "Loading"
                      : "Update University Web"}
                  </button>

                  <button
                    type="button"
                    className="btn btn-deep-orange waves-effect waves-light"
                    onClick={() => handleEditCancel()}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
            {/*<!-- contact-body -->*/}
          </div>
        )}
      </div>
    </>
  );
}
